export default [
  {
    name: 'getDepartment',
    method: 'GET',
    path: '/vue/system/department-get'
  },
  {
    name: 'getDepartmentList',
    method: 'POST',
    path: '/vue/system/department-page'
  },
  {
    name: 'saveDepartment',
    method: 'POST',
    path: '/vue/system/department-save'
  },
  {
    name: 'deleteDepartment',
    method: 'POST',
    path: '/vue/system/department-delete'
  },
  {
    name: 'initDepartment',
    method: 'GET',
    path: '/vue/system/department-getByParentId'
  },
  {
    name: 'loadDepartment',
    method: 'POST',
    path: '/vue/system/department-findList'
  },
  {
    name: 'searchDepartment',
    method: 'POST',
    path: '/vue/system/department-findList'
  }
];
